export interface StoredAccount {
  id: number;
  name: string;
  uuid?: string;
}

// Tab-scoped key (shared with Bridge) for the account this tab is viewing.
const STORAGE_KEY = 'xb:selected-account';

export function getStoredAccount(): StoredAccount | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;

    const record = parsed as Record<string, unknown>;
    if (typeof record.id !== 'number' || Number.isNaN(record.id)) return null;

    const account: StoredAccount = {
      id: record.id,
      name: typeof record.name === 'string' ? record.name : '',
    };
    if (typeof record.uuid === 'string') {
      account.uuid = record.uuid;
    }

    return account;
  } catch {
    // Malformed value or sessionStorage unavailable — treat as no account.
    return null;
  }
}

export function setStoredAccount(account: StoredAccount): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(account));
  } catch {
    // sessionStorage may be unavailable/quota-exceeded; ignore write failures.
  }
}

export function clearStoredAccount(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable; ignore remove failures.
  }
}
